import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Input, Modal, Row, Table } from "antd";
import {useContext, useState} from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { LineaEstrategica } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import {TemplateContext} from "../../../../utils/template_context";

interface IModalLineaEstrategica {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    lineaEstrategicas: LineaEstrategica[],
    obtenerLineasEstrategicas: Function,
    datos: LineaEstrategica,
    setDatos: Function,
}


export const ModalLineaEstrategica = ({ openModal, setOpenModal, isEdit, lineaEstrategicas, obtenerLineasEstrategicas, datos, setDatos }: IModalLineaEstrategica) => {
    const context = useContext(TemplateContext);
    const onCancel = () => {
        setOpenModal(false)
    }

    const [lineaEstrategica, setLineaEstrategica] = useState<LineaEstrategica>({
        nombre: ''
    })

    const [datosLineaEstrategica, setDatosLineaEstrategica] = useState<LineaEstrategica>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })

    const [modalVisible, setModalVisible] = useState(false);
    const editLineaEstrategica = (datos: LineaEstrategica) => {
        setDatosLineaEstrategica(datos);
        setModalVisible(true);
    }

    const addCiclo = async () => {
        if (lineaEstrategica.nombre !== '') {
            try {
                const data = await apiMaestras.crearLineaEstrategica(lineaEstrategica);
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerLineasEstrategicas();
                setLineaEstrategica({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const actualizarLineaEstrategica = async () => {
        try {
            const resp = await apiMaestras.actualizarLineaEstrategica(datosLineaEstrategica);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerLineasEstrategicas();
            setModalVisible(false)
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerLineasEstrategicas();
        setOpenModal(false);
        setLineaEstrategica({
            nombre: '',
        })
    }

    const guardarEdicion = async () => {
        try {
            const resp = await apiMaestras.actualizarLineaEstrategica(datos);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerLineasEstrategicas();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const deleteLineaEstrategica = async (datos: LineaEstrategica) => {
        try {
            const resp = await apiMaestras.eliminarLineaEstrategica(datos.id);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerLineasEstrategicas();
        } catch (error) {
            console.log(error);
        }
    }

    const columns: any = [
        {
            title: "Nombre línea estratégica",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: LineaEstrategica) => (
                <div className="controls">
                    <EditOutlined onClick={() => editLineaEstrategica(datos)} />
                    <DeleteOutlined onClick={() => deleteLineaEstrategica(datos)} />
                </div>
            )
        },
    ]


    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar linea estratégica</div>
                            )
                            :
                            (

                                <div>Crear línea estratégica</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                <>
                    {isEdit ?
                        (
                            <Row>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre línea estratégica
                                    </span>
                                    <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                            Nombre línea estratégica
                                        </span>
                                        <Input value={lineaEstrategica.nombre} onChange={(e) => setLineaEstrategica({ ...lineaEstrategica, nombre: e.target.value })} />
                                    </Col>
                                </Row>
                                <Row justify="end">
                                    <Col>
                                        <Button className="button-azul-radius" onClick={addCiclo}>Guardar</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div>Entidades creados</div>
                                    </Col>
                                    <Col>
                                        <Table
                                            dataSource={lineaEstrategicas}
                                            columns={columns}
                                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                            style={{ borderTop: "1px solid #C4C4C4" }}
                                            size="small"
                                            bordered={false}
                                            pagination={false}
                                            scroll={{ x: 1500, y: 300 }}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                </>
            </Modal>
            {modalVisible &&
                <Modal
                    title="Editar entidad"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarLineaEstrategica}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre línea estratégica
                            </span>
                            <Input value={datosLineaEstrategica.nombre} onChange={(e) => setDatosLineaEstrategica({ ...datosLineaEstrategica, nombre: e.target.value })} />
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
